






















































































import { Component, Vue, Mixins } from "vue-property-decorator";

import _ from "lodash";

import OrderChart from "@/views/statistics-analy/charts/order.vue";
import UserChart from "@/views/statistics-analy/charts/user.vue";
import DownChart from "@/views/statistics-analy/charts/download.vue";

import StadiumCountChart from "@/views/statistics-analy/charts/stadium_count.vue";
import UserTestChart from "@/views/statistics-analy/charts/test.vue";

import LatestUsers from "./home/users.vue";
import LatestWorkorder from "./home/workorder.vue";
import LatestEnterapply from "./home/enterapply.vue";
import LatestUpgrade from "./home/upgrade.vue";

import MyCommon from "@/mixins/common";

@Component({
  components: {
    OrderChart,
    UserChart,
    DownChart,
    StadiumCountChart,
    UserTestChart,
    LatestUsers,
    LatestWorkorder,
    LatestEnterapply,
    LatestUpgrade,
  },
})
export default class Home extends Mixins(MyCommon) {
  summaryData: any = {};

  hasPerm: boolean = true;

  async mounted() {
    if (!_.isEmpty(this.$store.state.user.userPerms)) {
    } else {
      this.hasPerm = false;
    }

    const res = await this.$store.dispatch("statistics/getSummary", {});
    // console.log(res)
    if (res && res.Data) {
      this.summaryData = res.Data;
    }
  }
}
